import React from 'react';

const Main = () => {
    return (
        <div id='studentCouncilMain'>
            <div className="container mt-4">
                {/* PDF Files with Clickable Icons and Headings */}
                <div className="row pt-5">
                    <h2 className="my-heading">Student Council</h2>
                    {/* Image Section */}
                    {/* PDF Files Section */}
                    <div className="col-md-12 mb-4">
                        {/* Heading for PDF Files */}
                        {/* <h2>Infrastructure</h2> */}
                        <br />
                        {/* PDF File Icons */}
                        <div className="row">
                            {/* Example PDF File 1 */}
                            <div className="col-md-12 mb-4">
                                <div className="pdf-container">
                                    <iframe
                                        className="pdf-viewer"
                                        src="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/Student-Council.pdf"
                                        width={1200}
                                        height={600}
                                        title='student council'
                                    />
                                </div>
                            </div>
                            {/* Repeat this block for other PDF files */}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Main;